import { render, staticRenderFns } from "./AlertLongStayListItem.vue?vue&type=template&id=2549ccae&scoped=true&lang=pug"
import script from "./AlertLongStayListItem.vue?vue&type=script&lang=ts"
export * from "./AlertLongStayListItem.vue?vue&type=script&lang=ts"
import style0 from "./AlertLongStayListItem.vue?vue&type=style&index=0&id=2549ccae&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2549ccae",
  null
  
)

export default component.exports